const locale = {
	login: {
		title: 'Login to your account',
		username: 'Email',
		password: 'Password',
		rememberMe: 'Remember Me',
		forgotPassword: 'Forgot Password?',
		login: 'Login',
		google: 'Log in with Google',
		askRegister: 'Don\'t have an account?',
		register: 'Create an account',
		or: 'OR',
		notFound: 'Incorrect username or password!',
		notFoundUser: 'The user not found!',
		notActivated: 'The email is not activated yet',
		isAcceptTerms: 'By signing in, you agree to our ',
	},
	common: {
		generalError: 'Oops! Something went wrong! <br />Help us improve your experience by sending an ',
		errorTicket: "error ticket...",
	},
	register: {
		title: 'Create an account',
		fname: 'First name',
		lname: 'Last name',
		email: 'Email',
		invalidEmail: 'Not a valid email!',
		password: 'Password',
		invalidPasswordDigit: 'Your password must contains at least one digit',
		invalidPasswordLen: 'Your password must have at least 8 characters',
		invalidPasswordChar: 'Your password must contains at least 1 uppercase & 1 lowercase characters',
		invalidPasswordSpecialChar: 'Your password must contains at least one special characters, i.e. ~!@#$%^&*_-+=`|(){}[]:;"\'<>,.?/',
		passwordConfirm: 'Password (Confirm)',
		invalidPassConfirm: 'Passwords must match!',
		hasSubscribeEmail: 'Join our mailing list to receive service updates, new services and suggestions',
		register: 'Create an account',
		askRegister: 'Already have an account?',
		login: 'Login',
		isAcceptTerms: 'By signing up, you agree to our',
		and: ' and the ',
		acceptTerms: 'terms and conditions',
		privacyPolicy: 'privacy policy',
		required: 'This field is required',
		duplicateError: `This account has been registered already. Please go to <a href="${process.env.PUBLIC_URL}/auth/login">login page</a> for sign in. <br/> <ul><li>If you have registered already but did not receive the activation email, please <a href="https://fraime.ai/contact">contact us</a>.</li><li>If you forgot your password, please <a href="${process.env.PUBLIC_URL}/auth/forgot-password">click here</a> to make a new password.</li></ul>`,
		NotAcceptableEmailError: 'Please enter a valid email address.',
		google: 'Sign up with Google',
		helpPassword: 'Your password must:\n- have at least 8 characters\n- contains at least 1 uppercase & 1 lowercase characters\n- contains at least one special characters, i.e. ~!@#$%^&*_-+=`|(){}[]:;"\'<>,.?/\n- contains at least one digit'
	},
	userActivate: {
		title: 'Your account is activated successfully!',
		body1: 'Thank you for choosing fraime,',
		body2: 'Adaptive AI Solutions',
		login: 'Go to login',
		expireActivation: 'This account has already been activated.'
	},
	unsubscribe: {
		title: 'Unsubscribe',
		question: 'Are you sure you want to cancel this subscription?',
		yes: 'Yes',
		no: 'No, back to home',
		successTitle: 'Unsubscribed successfully!',
		successMessage: 'You will no longer receive emails!',
		failTitle: 'Failed to unsubscribe your email',
		failReason: 'This might happen because of expired token, invalid token or invalid email',
		ticketUs: 'You can ticket us to fix this: ',
		home: 'Go to Home',
	},
	forgotPassword: {
		title: 'Recover your password',
		email: 'Email',
		submit: 'Send reset link',
		notFound: 'Email not found!',
		login: 'Go to login',
	},
	resetPassword: {
		title: 'Reset your password',
		email: 'Email',
		password: 'Password',
		passwordConfirm: 'Password (Confirm)',
		success: 'Your password was successfully reset.',
		submit: 'Reset my password',
		login: 'Go back to login',
		expireResetPassword: 'This link has expired.'
	},
	mailConfirm: {
		title: 'Confirm your email address!',
		confirm: 'A confirmation e-mail has been sent to',
		check: 'Check your inbox and click on the "Confirm my email" link to confirm your email address.',
		login: 'Go back to login',
	},
	resetEmail: {
		title: 'Reset your password',
		confirm: 'Your reset link has been sent to',
		check: 'Check your inbox and click on the "Reset my password" link to change your password.',
		login: 'Go back to login',
	},
	errors: {
		server: {
			internal_error: `Oops! Something went wrong! <br />Help us improve your experience by <a style="color: white !important; text-decoration: underline !important;" href="https://saiwa.ai/contact">contact us</a>.`
		},
		account: {
			login: {
				invalid_username_password: `<p>Oops! fraime could not find your email and/or password. Please make sure you have enter them correctly.</p>
					<p>- You may also use &ldquo;Log in with Google&rdquo; option</p>
					<br />
					<p>If you are sure none of these helps you, please <a href="https://saiwa.ai/contact">contact us</a> and we will help you soon.</p>`,
					not_active:`<p>Your email is not verified yet!</p>
					<br />
					<p>Kindly take a look in your inbox for the activation link; it might have landed in your spam or junk folder. If you're unable to locate the activation email, please don't hesitate to <a href="https://saiwa.ai/contact">contact us</a>.</p>
					`,
					locked:`<p>Oops! It seems you've entered an incorrect password multiple times.</p>
					<br />
					<p>For security reasons, your account has been temporarily locked. Please <a href="https://saiwa.ai/contact">contact support</a> to unlock and regain access.</p>
					`
			},
			forgot_password: {
				not_found: `This email does not seem to sign up already on fraime. Please re-check the entered email or in case of another issue please <a style="color: white !important; text-decoration: underline !important;" href="https://saiwa.ai/contact">contact us</a>.`
			},
			activation: {
				not_found: `Activation link is one-time usage for your security. Your account is activated already or in case of another issue please <a style="color: white !important; text-decoration: underline !important;" href="https://saiwa.ai/contact">contact us</a>.`
			},
			register: {
			}
		},
		license: {
			one_active_license_limit: `You have already an active license, so you can not buy a new one right now.
			<br/>
			If you are not satisfied with your current license features, please <a style="color: white !important; text-decoration: underline !important;" href="${process.env.PUBLIC_URL}/ticket/new-ticket/1/3">leave us a ticket</a> to discuss about the update.
			<br/>
			Normally, you can request for a new license from one week before your active license expires.`
		}
	}
};

export default locale;
